import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authSrv = inject(AuthService);
  const router = inject(Router);
  
  if (authSrv.isUserLoggedIn) {
    return true;
  }
  
  // Return a UrlTree to redirect to /auth, passing the current URL as a parameter
  return router.createUrlTree(['/auth'], { queryParams: { redirect_url: state.url } });
};
